module.exports = __webpack_public_path__ + "img/ИФ-1(А)-043.5330f90d.png";